var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.props.loading),expression:"props.loading"}],attrs:{"element-loading-background":"#1c2c44"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }